package com.essntl.features.profile.data.repository

import com.essntl.core.supabase.delete
import com.essntl.core.supabase.getAll
import com.essntl.core.supabase.getById
import com.essntl.core.supabase.insert
import com.essntl.core.supabase.update
import com.essntl.core.utils.repository.Repository
import com.essntl.features.profile.data.supabase.ProfileSupabaseDataSource
import com.essntl.features.profile.data.supabase.toRequestMap
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.profile.domain.repository.ProfileRepository
import org.koin.core.annotation.Single

@Single(binds = [ProfileRepository::class])
internal class ProfileRepositoryImpl internal constructor(
    private val supabase: ProfileSupabaseDataSource,
) : Repository(), ProfileRepository {
    override suspend fun getById(id: String): Result<ProfileModel> =
        runCatching {
            supabase
                .getById(id)
                .toModel()
        }

    override suspend fun getAll(): Result<List<ProfileModel>> =
        runCatching {
            supabase
                .getAll {}
                .map { it.toModel() }
        }

    override suspend fun getAll(page: Long, limit: Int): Result<List<ProfileModel>> =
        runCatching {
            supabase
                .getAll(page = page, limit = limit)
                .map { it.toModel() }
        }

    override suspend fun insert(profile: ProfileModel): Result<ProfileModel> =
        runCatching {
            supabase
                .insert(profile.toRequestMap())
                .toModel()
        }

    override suspend fun update(profile: ProfileModel): Result<ProfileModel> =
        runCatching {
            supabase
                .update(id = profile.id, profile.toRequestMap())
                .toModel()
        }

    override suspend fun delete(profile: ProfileModel): Result<Unit> =
        runCatching {
            supabase
                .delete(profile.id)
        }
}
